<template>
  <main class="w-100 vh-100">
    <div class="h-100 w-100 main-container">
      <div class="d-flex justify-content-center">
        <img
          :src="useAsset('img/logo_bg_black.svg')"
          alt="payjoy logo"
          class="mx-auto my-5"
        />
      </div>
      <h1 class="text-center fw-bold">
        {{ t("NOT_PRIOR_BORROWER.CREDIT_NOT_FOUND") }}
      </h1>
      <p class="text-center text-white px-4">
        {{ t("NOT_PRIOR_BORROWER.CONTACT_SUPPORT") }}
      </p>
      <img
        :src="useAsset('img/core-app-onboarding/not_available.svg')"
        alt="not available"
        class="position-absolute bottom-0"
      />
    </div>
  </main>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import useAsset from "@/apps/core-app-onboarding/helpers/useAsset";
import { setLanguage } from "@/apps/core-app-onboarding/helpers/translations.helper";
import { useI18n } from "@/apps/core-app-onboarding/composables/useI18n";

export default defineComponent({
  name: "NotAvailableView",
  methods: { useAsset },
  onBeforeMount() {
    setLanguage(this);
  },
  setup() {
    const { t } = useI18n();
    return { t };
  },
});
</script>

<style lang="scss" scoped>
@import "@/apps/core-app-onboarding/styles/index.scss";
html {
  background-color: $pj-color-green;
}
main {
  background-color: $pj-color-green;
}

h1 {
  color: white;
  text-align: center;
  font-feature-settings: "liga" off, "clig" off;
  font-family: Inter;
  font-size: 1.25rem;
  font-style: normal;
}

hr {
  width: 85%;
  border-top: 2px solid white;
  opacity: 100%;
}

p {
  text-align: center;
  font-feature-settings: "liga" off, "clig" off;
  font-family: Inter;
  font-size: 1rem;
  font-style: normal;
  color: white;
}

a {
  color: #d3ff4b;
  font-feature-settings: "liga" off, "clig" off;
  font-family: Inter;
  font-size: 1rem;
  text-decoration: none;
  font-style: italic;
  font-weight: 500;
}
</style>
